import { prayerRamadanDe } from './golf4App.de.js';
// Duits (de-DE), weer en gebedstijden: zelfde vorm als weatherPrayer.nl.ts. NEUTRAAL zoals nl: in
// geo (behalve variants.prayer/both) en in weather.* nooit Gebet, Moschee, Islam of de oproep.
// Duitse zelfstandige naamwoorden houden hun hoofdletter, ook midden in een zin (itemWords, call).
// Kinderzinnen positief en concreet, nooit de plannen van de ouder tegenspreken. Turkse en
// Arabische gebedsnamen blijven zoals in nl; alleen "Zonsopkomst" wordt Sonnenaufgang.
export const weatherPrayerDe = {
    geo: {
        title: 'Standort',
        intro: 'Wähle eure Postleitzahl oder euren Wohnort. Wir speichern nur ein Gebiet von etwa einem Kilometer.',
        searchLabel: 'Postleitzahl oder Wohnort',
        searchPlaceholder: 'Zum Beispiel 3511 AA oder Utrecht',
        searchButton: 'Suchen',
        searchHint: 'Eine Hausnummer ist nicht nötig; die schicken wir auch nicht mit.',
        noResults: 'Nichts gefunden. Versuch es mit einer Postleitzahl oder einem Ortsnamen.',
        tooMany: 'Nicht so schnell: Versuch es in einer Minute noch einmal.',
        chosen: 'Gebiet: {label}',
        privacy: 'Wir speichern keine Straße, keine Hausnummer und keinen genauen Ort. Verbundene Verwandte, Gäste und Kalender-Links sehen das nie.',
        remove: 'Standort löschen',
        removed: 'Standort gelöscht.',
        variants: {
            weather: {
                settingsBody: 'Für das Wetter auf dem Board',
                why: 'Warum? Für das Wetter auf dem Board. Für nichts anderes.',
                removeConfirm: 'Wir löschen den Standort eurer Familie und der Tablets. Das Wetter bleibt dann stehen, bis du einen neuen wählst. Weiter?',
                askBody: 'Einmalig, für das Wetter. Wir speichern nur ein Gebiet von etwa einem Kilometer.',
            },
            prayer: {
                settingsBody: 'Für die Gebetszeiten',
                why: 'Warum? Für die Gebetszeiten. Für nichts anderes.',
                removeConfirm: 'Wir löschen den Standort eurer Familie und der Tablets. Die Gebetszeiten bleiben dann stehen, bis du einen neuen wählst. Weiter?',
                askBody: 'Einmalig, für die Zeiten auf dem Board. Wir speichern nur ein Gebiet von etwa einem Kilometer.',
            },
            both: {
                settingsBody: 'Für das Wetter und die Gebetszeiten',
                why: 'Warum? Für das Wetter auf dem Board und die Gebetszeiten. Für nichts anderes.',
                removeConfirm: 'Wir löschen den Standort eurer Familie und der Tablets. Wetter und Gebetszeiten bleiben dann stehen, bis du einen neuen wählst. Weiter?',
                askBody: 'Einmalig, für das Wetter und die Zeiten auf dem Board. Wir speichern nur ein Gebiet von etwa einem Kilometer.',
            },
        },
        device: {
            title: 'Standort dieses Tablets',
            household: 'Wie die Familie',
            own: 'Den Standort dieses Tablets verwenden',
            ownHint: 'Praktisch, wenn dieses Tablet woanders steht, zum Beispiel in einem Ferienhaus.',
            otherHome: 'Steht das Tablet bei jemand anderem zu Hause? Dann speichern wir auch von diesem Haus ein Gebiet von etwa einem Kilometer. Sag der Person Bescheid.',
            pending: 'Auf dem Tablet erscheint eine Frage. Tippe dort auf „Ja, einmalig bestimmen“.',
            measured: 'Gebiet dieses Tablets: {label}',
            far: 'Dieses Tablet steht etwa {km} km von eurer Familienadresse entfernt.',
            remeasure: 'Neu bestimmen',
            failed: 'Das Tablet konnte seinen Standort nicht bestimmen. Wir verwenden den Standort der Familie.',
        },
        kiosk: {
            askTitle: 'Darf dieses Tablet seinen Standort verwenden?',
            yes: 'Ja, einmalig bestimmen',
            no: 'Nein',
            busy: 'Wird gesucht…',
            done: 'Geklappt: {label}',
            failed: 'Das hat nicht geklappt. Wir verwenden den Standort der Familie.',
        },
        web: {
            choose: 'Standort wählen',
            change: 'Standort ändern',
            none: 'Noch kein Standort gewählt.',
            area: 'Gebiet: {label}',
            tablets: 'Tablets',
            tabletsNone: 'Noch keine Tablets gekoppelt.',
            edit: 'Ändern',
            save: 'Speichern',
            saved: 'Gespeichert',
            cancel: 'Abbrechen',
            country: 'Land',
            countryNl: 'Niederlande',
            countryOther: 'Anderes Land',
            city: 'Ort',
            postcode: 'Postleitzahl',
            countryCode: 'Ländercode (z. B. BE oder DE)',
            searching: 'Wird gesucht…',
            pick: 'Wähle dein Gebiet',
            removeTitle: 'Standort löschen?',
            unavailable: 'Die Suche klappt gerade nicht. Versuch es später noch einmal.',
            requested: 'Messung angefordert',
            deviceSame: 'Wie die Familie',
            deviceSameWith: 'Wie die Familie ({label})',
        },
        credits: {
            pdok: 'Standortdaten: PDOK/Kadaster',
            osm: '© OpenStreetMap-Mitwirkende (ODbL)',
        },
    },
    weather: {
        title: 'Wetter',
        settingsBody: 'Jacke, Gummistiefel oder Sonnencreme? Tipps für die Momente, in denen die Kinder aus dem Haus gehen',
        enabled: 'Wetter anzeigen',
        needsLocation: 'Wähle zuerst einen Standort, dann zeigen wir das Wetter.',
        showInBanners: 'In der Abfahrtsmeldung („Schule um 8:15: Regenjacke und Gummistiefel“)',
        adjust: 'Anpassen',
        morning: 'Der Morgen geht von {start} bis {end}',
        thresholdsTitle: 'Wann welcher Tipp',
        thresholdsNote: 'Sonne, Hitze, Wind und Glätte folgen RIVM und KNMI. Die Grenzen für Jacken und Pullis sind unser eigener Standard: Pass sie ruhig an.',
        thresholds: {
            sweaterBelowC: 'Pulli unter {value} °C (gefühlt)',
            coatBelowC: 'Jacke an unter {value} °C',
            thickCoatBelowC: 'Dicke Jacke unter {value} °C',
            hatGlovesAtOrBelowC: 'Mütze und Handschuhe ab {value} °C und kälter',
            umbrella: 'Regenschirm vorschlagen bei Regen und wenig Wind',
            shortsFromC: 'Kurze Hose geht ab {value} °C und trocken',
            waterBottleFromC: 'Trinkflasche mit ab {value} °C',
        },
        perChild: 'Pro Kind',
        coldDelta: {
            label: 'Friert schnell',
            value: { one: '{count} Grad früher eine Jacke', other: '{count} Grad früher eine Jacke' },
            warmer: { one: '{count} Grad später eine Jacke', other: '{count} Grad später eine Jacke' },
            none: 'Wie alle',
            hint: 'Friert ein Kind schnell? Stell die Zahl höher: Dann bekommt es so viele Grad früher eine Jacke. Niedriger: später.',
        },
        uvClearSky: 'UV-Index {value} (bei klarem Himmel)',
        uvCloud: 'UV-Index {value}',
        feelsLike: 'Gefühlt {value} °C',
        wind: 'Wind {bft} Beaufort',
        stale: 'Wetter gerade unbekannt',
        attribution: 'Wetterdaten: MET Norway',
        feel: { cold: 'kalt', chilly: 'frisch', mild: 'angenehm', warm: 'warm', hot: 'heiß' },
        itemLabels: {
            warning: 'Achtung',
            thunder: 'Gewitter',
            very_windy: 'Starker Wind',
            slippery: 'Glatt',
            very_cold: 'Sehr kalt',
            thick_coat: 'Dicke Jacke',
            coat: 'Jacke',
            sweater: 'Pulli',
            raincoat: 'Regenjacke',
            boots: 'Gummistiefel',
            hat_gloves: 'Mütze und Handschuhe',
            no_umbrella: 'Kapuze auf',
            umbrella: 'Regenschirm',
            windy: 'Wind',
            shade: 'Raus aus der Sonne',
            sunscreen: 'Eincremen',
            sun_hat: 'Kappe auf',
            extra_drinks: 'Viel trinken',
            water_bottle: 'Trinkflasche',
            midday_shade: 'Schatten',
            reapply: 'Nachcremen',
            shorts: 'Kurze Hose',
        },
        itemWords: {
            warning: 'Achtung',
            thunder: 'rein, wenn es donnert',
            very_windy: 'sehr starker Wind: auf dem Rad gut festhalten',
            slippery: 'es kann glatt sein: langsam gehen und Rad fahren',
            very_cold: 'sehr kalt: nur kurz draußen',
            thick_coat: 'dicke Jacke',
            coat: 'Jacke',
            sweater: 'Pulli',
            raincoat: 'Regenjacke',
            boots: 'Gummistiefel',
            hat_gloves: 'Mütze und Handschuhe',
            no_umbrella: 'kein Schirm, Kapuze auf',
            umbrella: 'Regenschirm',
            windy: 'starker Wind: Vorsicht auf dem Rad',
            shade: 'raus aus der Sonne',
            sunscreen: 'eincremen',
            sun_hat: 'Kappe auf',
            extra_drinks: 'viel trinken und ruhig im Schatten spielen',
            water_bottle: 'Trinkflasche mitnehmen',
            midday_shade: 'zwischen 12 und 3 im Schatten spielen',
            reapply: 'um 12 Uhr nachcremen',
            shorts: 'kurze Hose geht',
        },
        waterproof: 'dicke wasserdichte Jacke',
        headline: {
            rain: 'Um {time} regnet es: {items}.',
            wet: 'Heute Morgen kann es nass sein: {items}.',
            wetLater: 'Gegen {time} kann es nass sein: {items}.',
            snow: 'Um {time} schneit es: {items}.',
            thunder: 'Um {time} kann es gewittern: rein, wenn es donnert.',
            cold: 'Kalt draußen um {time}: {items}.',
            hot: 'Es wird warm: {items}.',
            coolThenWarm: 'Frisch um {time}, später warm: {items}.',
            sun: 'Sonnig: {items}.',
            wind: 'Starker Wind um {time}: Vorsicht auf dem Rad.',
            nice: 'Um {time}: {feel}es Wetter.',
            niceWith: 'Um {time}: {feel}es Wetter, {items}.',
            warning: '{kids}',
            departure: '{title} um {time}: {items}.',
        },
        and: 'und',
        warningKids: {
            wind: 'Es ist sehr windig. Mach deine Jacke gut zu und bleib nah bei Mama oder Papa.',
            rain: 'Es regnet sehr viel. Regenjacke an und Gummistiefel mit.',
            thunder: 'Es kann ein Gewitter kommen. Wenn es donnert, gehen wir rein.',
            snow: 'Es schneit viel. Gummistiefel an und langsam gehen.',
            ice: 'Draußen ist es glatt. Langsam gehen, nicht rennen.',
            heat: 'Es ist sehr heiß. Viel trinken und im Schatten spielen.',
            cold: 'Es ist sehr kalt. Warm anziehen: Mütze und Handschuhe.',
            fog: 'Es ist neblig. Bleib nah bei Mama oder Papa.',
            other: 'Heute gut auf das Wetter achten.',
        },
        warningLevel: { yellow: 'Warnstufe Gelb', orange: 'Warnstufe Orange', red: 'Warnstufe Rot' },
        web: {
            todayTitle: 'Wetter heute',
            todayTitleAt: 'Wetter heute · {label}',
            tomorrowTitle: 'Wetter morgen',
            tomorrowTitleAt: 'Wetter morgen · {label}',
            nowLabel: 'Jetzt',
            tomorrowLabel: 'Morgen',
            invite: 'Möchtest du Wettertipps auf dem Board?',
            inviteBody: 'Jacke, Gummistiefel oder Sonnencreme: Wir sagen es in den Momenten, in denen die Kinder aus dem Haus gehen.',
            notNow: 'Nicht jetzt',
            chooseLocation: 'Standort wählen',
            settings: 'Einstellungen',
            showOnKiosk: 'Auf dem Board',
            save: 'Speichern',
            saved: 'Gespeichert',
            resetDefaults: 'Standard wiederherstellen',
            morningStart: 'Morgen ab',
            morningEnd: 'Morgen bis',
            alsoFor: '{name}: {items}',
            everyone: 'Alle',
            tempNow: '{temp}°',
            staleBody: 'Wir holen das Wetter so schnell wie möglich neu.',
            childNone: 'Noch keine Kinder in der Familie.',
            offTitle: 'Wetter ausschalten?',
            offConfirm: 'Nichts anderes nutzt den Standort. Wir löschen dann auch den Standort eurer Familie und der Tablets. Weiter?',
            offConfirmButton: 'Ausschalten und Standort löschen',
            offNotice: 'Das Wetter ist aus.',
            offNoLocation: 'Das Wetter ist aus. Wähle einen Standort; danach schaltest du das Wetter hier mit einem Tippen ein.',
            turnOn: 'Wetter einschalten',
            less: 'Weniger',
            more: 'Mehr',
        },
        warningSource: {
            knmi: 'Quelle: KNMI',
            meteoalarm: 'Quelle: KNMI über MeteoAlarm',
            fake: 'Quelle: Test',
        },
        /** Niederschlag über dem Diagramm des Widgets Niederschlag. */
        precip: {
            dryAll: 'Trocken in den nächsten {hours} Stunden.',
            nowUntil: 'Jetzt {kind}, trocken ab {end}.',
            nowLong: '{kind} in den nächsten Stunden.',
            fromUntil: '{kind} ab {start}, trocken ab {end}.',
            dryUntil: 'Trocken bis {start}, danach {kind}.',
            words: {
                drizzle: 'Nieselregen',
                rain_light: 'leichter Regen',
                rain: 'Regen',
                rain_heavy: 'starker Regen',
                sleet: 'Schneeregen',
                snow: 'Schnee',
                hail: 'Hagel',
                thunder: 'Gewitterschauer',
            },
        },
    },
    prayer: {
        // Golf 4: Ramadan op het bord (DESIGN §8.GB.14).
        ramadan: prayerRamadanDe,
        title: 'Gebetszeiten',
        settingsBody: 'Die Zeiten für euer Gebiet, auf dem Board im Wohnzimmer',
        enabled: 'Gebetszeiten verwenden',
        needsLocation: 'Wähle zuerst einen Standort. Dann berechnen wir die Zeiten für euer Gebiet.',
        privacy: 'Das gehört zu „Was zu unserer Familie passt“. Nur ihr Eltern seht die Einstellungen; verbundene Verwandte und Gäste nie.',
        boardVisible: 'Achtung: Die Zeiten und die Karte stehen auf dem Board, also sieht sie jeder im Raum (auch Besuch oder ein Babysitter).',
        call: { turkish: 'Ezan', arabic: 'Adhan' },
        callTitle: { turkish: 'Ezan', arabic: 'Adhan' },
        setup: {
            quickTitle: 'Gebetszeiten',
            quickBody: 'Wir rechnen mit {method}. Passt das zu eurer Moschee? Dann bist du fertig. Abstimmen und Ton pro Gebet geht jederzeit später.',
            quickNoCall: 'Es gibt noch keine {call}-Aufnahme. Bis ihr selbst eine hochladet, ertönt auf dem Tablet im Wohnzimmer ein leises Glöckchen.',
            quickTone: 'Bei „Welche Aufnahme?“ ist jetzt das leise Glöckchen gewählt. Möchtest du den {call} hören? Wähle dort über „Mehr einstellen“ die mitgelieferte Aufnahme.',
            quickTimes: 'Heute in {place}',
            quickDone: 'Fertig',
            quickMore: 'Mehr einstellen',
            step1: 'Wie berechnen wir die Zeiten?',
            step1Body: 'Nicht alle Moscheen rechnen gleich. Wähle, was eure Moschee verwendet, oder lass unsere Wahl stehen.',
            step2: 'Auf die eigene Moschee abstimmen',
            step2Body: 'Leg den Gebetsplan deiner Moschee daneben. Weicht eine Zeit ab, verschieb sie. Im Sommer weichen Moscheen manchmal eine halbe Stunde oder mehr ab: Stell dann pro Monat ein oder lies den Jahresplan ein.',
            step3: 'Was ertönt auf dem Tablet?',
            step3Body: 'Der {call} ertönt auf dem Tablet im Wohnzimmer. Andere Tablets bleiben still, außer du schaltest sie ein.',
            step3BodyNoCall: 'Es gibt noch keine {call}-Aufnahme. Bis ihr unten selbst eine hochladet, ertönt bei „{callTitle}“ das leise Glöckchen. Andere Tablets bleiben still, außer du schaltest sie ein.',
            step3BodyTone: 'Bei „{callTitle}“ ertönt jetzt das leise Glöckchen, weil es bei „{step4}“ gewählt ist. Andere Tablets bleiben still, außer du schaltest sie ein.',
            step4: 'Welche Aufnahme?',
            done: 'Fertig. Das nächste Gebet steht jetzt auf dem Board.',
        },
        method: {
            diyanet: 'Diyanet (Türkei)',
            mwl: 'Muslim World League',
            uoif: 'UOIF (Frankreich)',
            morocco: 'Marokko',
            jafari: 'Jafari (schiitisch)',
            eu_joint: 'Europäischer gemeinsamer Kalender (Diyanet · Milli Görüş)',
        },
        methodInSentence: {
            diyanet: 'dem Kalender der Diyanet (Türkei)',
            mwl: 'der Muslim World League',
            uoif: 'der UOIF (Frankreich)',
            morocco: 'der marokkanischen Methode',
            jafari: 'der Jafari-Methode (schiitisch)',
            eu_joint: 'dem Europäischen gemeinsamen Kalender (Diyanet · Milli Görüş)',
        },
        methodHint: {
            diyanet: 'Der Kalender für die Türkei. Türkische Moscheen in Europa nutzen den europäischen Kalender oben.',
            mwl: 'In Europa weit verbreitet. Ein guter Standard, wenn du es nicht weißt.',
            uoif: 'Späteres Fajr und früheres Isha (12°).',
            morocco: 'Was marokkanische Moscheen oft verwenden.',
            jafari: 'Maghrib nach der Dämmerung, etwa eine Viertelstunde nach Sonnenuntergang.',
            eu_joint: 'Seit 2023 derselbe Kalender für Diyanet (ISN, DITIB) und Milli Görüş in Europa. Wählen Sie dies, wenn Ihre Moschee türkisch ist.',
        },
        asrSchool: { standard: 'Standard (erste Zeit)', hanafi: 'Hanafi (später am Nachmittag)' },
        asrSource: {
            title: 'Zeit für {asr}',
            madhab: 'Folgt eurer Rechtsschule',
            manual: 'Selbst eingestellt',
            unset: 'Standard',
            follow: 'Wieder der Rechtsschule folgen',
            madhabLink: 'Rechtsschule wählen oder ändern',
            why: {
                hanafi: 'Ihr folgt der hanafitischen Schule: {asr} später am Nachmittag.',
                other_madhab: 'Ihr folgt der Schule {madhab}: {asr} zur Standardzeit.',
                calendar: 'Ihr folgt der hanafitischen Schule. Der Kalender von Diyanet und Milli Görüş nennt für {asr} die erste Zeit (asr-ı evvel), wie eure Moschee. Lieber die spätere Zeit (asr-ı sani)? Wählt oben „{hanafi}“.',
                no_madhab: 'Noch keine Rechtsschule gewählt: {asr} zur Standardzeit.',
            },
            manualWhy: 'Das habt ihr selbst gewählt. Eine andere Rechtsschule ändert daran nichts.',
        },
        madhabSuggestion: {
            body: 'Ihr folgt der hanafitischen Schule. Türkische Moscheen in Europa rechnen mit {method}.',
            apply: 'Diesen Kalender verwenden',
            applied: 'Wir rechnen jetzt mit {method}.',
        },
        naming: { turkish: 'Türkische Namen', arabic: 'Arabische Namen' },
        namingTitle: 'Namen der Gebete',
        names: {
            turkish: {
                fajr: 'Sabah',
                sunrise: 'Güneş',
                dhuhr: 'Öğle',
                asr: 'İkindi',
                maghrib: 'Akşam',
                isha: 'Yatsı',
            },
            arabic: {
                fajr: 'Fajr',
                sunrise: 'Sonnenaufgang',
                dhuhr: 'Dhuhr',
                asr: 'Asr',
                maghrib: 'Maghrib',
                isha: 'Isha',
            },
        },
        cardNames: {
            turkish: { fajr: 'Sabah', dhuhr: 'Öğle', asr: 'İkindi', maghrib: 'Akşam', isha: 'Yatsı' },
            arabic: { fajr: 'Fajr', dhuhr: 'Dhuhr', asr: 'Asr', maghrib: 'Maghrib', isha: 'Isha' },
        },
        sunriseNote: 'Der Sonnenaufgang ist das Ende der Zeit für {fajr}. Dabei ertönt nie etwas.',
        offsets: {
            title: 'Abweichung pro Gebet',
            sameAllYear: 'Das ganze Jahr gleich',
            perMonth: 'Pro Monat',
            month: 'Im {month}',
            later: '{value} Min. später',
            earlier: '{value} Min. früher',
            seeded: 'Abgestimmt auf die Diyanet-Tabelle von Rotterdam, nur für September geprüft. Prüf es mit deiner eigenen Moschee, besonders im Sommer.',
            tableDay: 'Diese Zeiten kommen aus dem Gebetsplan deiner Moschee. Abweichungen gelten nur für Tage, die nicht im Plan stehen.',
            compare: 'Mit dem Gebetsplan deiner Moschee vergleichen',
            dstCheck: 'Die Uhr wurde umgestellt. Passt es noch zum Gebetsplan eurer Moschee?',
            dstYes: 'Ja, passt',
            dstAdjust: 'Anpassen',
        },
        table: {
            title: 'Gebetsplan deiner Moschee einlesen',
            body: 'Füge den Jahresplan ein (pro Zeile: Datum; {fajr}; Sonnenaufgang; {dhuhr}; {asr}; {maghrib}; {isha}). Ein Tag aus dem Plan ersetzt unsere Berechnung.',
            read: 'Einlesen',
            result: { one: '{count} Tag eingelesen', other: '{count} Tage eingelesen' },
            badLines: 'Nicht lesbar: Zeile {lines}',
            fromTable: 'Aus dem Gebetsplan deiner Moschee',
            remove: 'Gebetsplan entfernen',
        },
        sound: {
            adhan: '{callTitle}',
            adhanPending: '{callTitle} (noch keine Aufnahme: jetzt das Glöckchen)',
            adhanTone: '{callTitle} (jetzt das Glöckchen, siehe „{step4}“)',
            chime: 'Leises Glöckchen',
            silent: 'Still (nur die Karte)',
        },
        yearRange: '{name}: im {month} gegen {time}',
        fajrWarning: '{fajr} ist vor Sonnenaufgang. Der {call} weckt dann das ganze Haus.',
        fajrNeedsRecording: 'Zu {fajr} gehört ein eigener Gebetsruf (mit „as-salatu khayrun min an-nawm“), deshalb ertönt dort nie der normale. Lade eine eigene Aufnahme für {fajr} hoch oder wähle das Glöckchen.',
        quiet: {
            title: 'Spätabends und nachts',
            body: 'Nach {from} und bis {until} ertönt statt des {call}s:',
            chime: 'ein leises Glöckchen',
            silent: 'nichts (nur die Karte im Wohnzimmer)',
            adhan: 'trotzdem der {call}',
            hint: 'Im Juni fällt {isha} auf etwa Mitternacht und {maghrib} auf nach zehn Uhr. Mit dem Glöckchen bleibt das Haus ruhig.',
        },
        /** Eenmalige melding na het overzetten naar de gezamenlijke kalender (0041). */
        methodNotice: 'Die Gebetszeiten folgen jetzt dem europäischen Kalender von Diyanet und Milli Görüş; im Sommer liegen {fajr} und {isha} dadurch anders.',
        methodNoticeOk: 'OK',
        /** Eerlijk over eu_joint (gefit op de Diyanet-tabellen, niet officieel; review g6b fs r1). */
        methodApprox: 'Wir rechnen den gemeinsamen Kalender selbst nach. Für Rotterdam und Amsterdam stimmt das ganze Jahr auf 1 bis 2 Minuten mit der Tabelle überein. Keine Gebetszeit und kein Adhan auf dem Tablet kommt früher als die Diyanet-Tabelle: Wir runden auf, und bei {fajr} rechnen wir 2 Minuten dazu, von Mitte April bis Mitte September 10. Imsak, der Beginn des Fastens, ist dagegen nie später als die Tabelle; im Ramadan stehen Imsak und {fajr} beide auf der Tafel. Anderswo, vor allem von Mitte April bis Mitte September, kann Ihre Moschee einige Minuten abweichen (bis etwa 9). Stimmen Sie es mit Ihrer Moschee ab, zum Beispiel mit ein paar Minuten bei {fajr} unter Abweichung pro Gebet, oder lesen Sie den Plan Ihrer Moschee ein.',
        /** Korte zin bij de tijden (Vandaag, tablet) in de zomerweken van eu_joint. */
        methodTune: 'Sommerzeiten: Ihre Moschee kann einige Minuten abweichen. Stimmen Sie es mit Ihrer Moschee ab.',
        /** Opnamebibliotheek (golf 6b, DESIGN §8.GB.15). */
        library: {
            intro: 'Wählen Sie eine Aufnahme pro Region. Hören Sie erst kurz hinein: Es sind echte Aufnahmen, manchmal mit Stadtgeräuschen oder Vögeln.',
            regions: {
                arabic: 'Arabischer Stil',
                hijaz: 'Mekka (Hidschas)',
                turkish: 'Istanbul und Türkei',
                maghreb: 'Marokko',
                egypt: 'Ägypten',
                levant: 'Jordanien',
                southeast_asia: 'Malaysia',
                central_asia: 'Kasachstan',
                europe: 'Europa',
                other: 'Sonstige (Ort unbekannt)',
            },
            places: {
                mecca: 'Mekka, Masjid al-Haram',
                istanbul: 'Istanbul (kurz)',
                istanbul_fatih: 'Istanbul, Kalenderhane-Moschee',
                mardin: 'Mardin, morgens',
                patara: 'Patara, Dorf, morgens',
                casablanca: 'Casablanca, Hassan-II.-Moschee',
                marrakech: 'Marrakesch, Djemaa el Fna',
                marrakech_medina: 'Marrakesch, Medina, morgens',
                quseir: 'El Quseir, am Meer',
                amman: 'Amman, morgens',
                kuala_lumpur: 'Kuala Lumpur, morgens',
                shalqar: 'Schalqar',
                malmo: 'Malmö, morgens',
                indoor: 'Freitag, drinnen aufgenommen',
            },
            option: '{place} ({year})',
            meta: '{author} · {license} · {duration}',
            fajrTitle: 'Aufnahme für {fajr}',
            fajrBody: 'Zu {fajr} gehört ein eigener Ruf mit „as-salatu khayrun min an-nawm“. Wählen Sie eine Morgenaufnahme oder laden Sie eine eigene hoch; sonst ertönt zu {fajr} der Gong.',
            fajrNone: 'Keine (der Gong)',
            fajrUnverified: 'Morgenaufnahme, der Morgensatz ist noch nicht geprüft',
            sources: 'Quellen und Lizenzen',
            sourcesIntro: 'Alle Aufnahmen sind frei nutzbar. Zu jeder Aufnahme stehen hier Titel, Urheber, Quelle und Lizenz. Wir haben Stille am Anfang und Ende entfernt, die Lautstärke angeglichen und nach AAC umgewandelt.',
            by: '„{title}“ von {author}, über {platform}',
            shareAlike: 'Unsere bearbeitete Fassung steht ebenfalls unter {license}.',
            report: 'Stimmt eine Quelle nicht? Schreiben Sie an support@amumin.com, dann entfernen wir die Aufnahme.',
        },
        audio: {
            builtin_a: '{callTitle}, arabischer Stil',
            builtin_b: '{callTitle}, arabischer Stil (kürzer)',
            sunniNote: 'Diese Aufnahmen haben den sunnitischen Text.',
            shiaNote: 'Unsere Aufnahmen haben den sunnitischen Text. Wähle das Glöckchen oder eine eigene Aufnahme.',
            tone: 'Leises Glöckchen (eigener Klang, anders als die Aufgaben-Glöckchen)',
            own: 'Eigene Aufnahme hochladen (m4a oder mp3, höchstens 5 Minuten)',
            ownFajr: 'Eigene Aufnahme für {fajr}',
            credits: 'Über die Aufnahmen',
        },
        kidsMayStop: 'Kinder dürfen den {call} stoppen',
        kidsMayStopHint: 'Aus: Der Stopp-Knopf ist bei der Elternbedienung.',
        device: {
            title: 'Auf welchen Tablets?',
            sound: '{callTitle} abspielen',
            soundAny: 'Ton beim Gebet',
            line: 'Nächstes Gebet in der Kopfzeile',
            card: 'Karte beim Gebet',
            cardNight: 'In einem Zimmer nachts nie eine Karte.',
            volume: 'Lautstärke',
            volumeIos: 'Auf einem iPad stellst du die Lautstärke mit den Tasten an der Seite ein.',
            test: 'Auf dem Tablet testen',
            locked: '{name}: Ton ist aus. Tippe einmal auf den Bildschirm dieses Tablets.',
            unsupported: '{name}: Dieses Tablet kann keinen Ton abspielen.',
            outcome: {
                played: 'Ertönte um {time}',
                card_locked: 'Um {time} still: Ton war aus',
                card_late: 'Um {time} still: zu spät gesehen',
                load_failed: 'Um {time} still: Aufnahme nicht geladen',
                skipped: 'Um {time} übersprungen',
            },
            checklist: 'Lass den Bildschirm an (Automatische Sperre: Nie). Im geführten Zugriff: Standby-Taste aus, Lautstärketasten an. Schalte das iPad nicht mit der Standby-Taste aus: Dann bleiben {isha} und {fajr} still.',
        },
        kiosk: {
            next: '{name} {time}',
            nextIn: '{name} {time} · in {left}',
            inMinutes: 'in {n} Min.',
            inHours: 'in {n} Std.',
            now: 'Jetzt: {name}',
            cardTitle: 'Zeit für das {name}-Gebet',
            playing: '{callTitle} läuft',
            playingChime: 'Glöckchen ertönt',
            cardStop: 'Stopp',
            cardStopHold: 'Zum Stoppen festhalten',
            cardClose: 'Schließen',
            soundLocked: 'Tippen für Ton',
            soundLockedLong: 'Ton ist aus. Tippen zum Einschalten.',
            unsupported: 'Dieses Tablet kann keinen Ton abspielen',
            unknown: 'Gebetszeiten gerade unbekannt',
        },
        question: {
            title: 'Gebetszeiten auf dem Board?',
            body: 'Dann steht das nächste Gebet oben auf dem Board, und zu den Gebetszeiten ertönt der {call} auf dem Tablet im Wohnzimmer.',
            body2: '{fajr} ist standardmäßig still. Alles kannst du später ändern.',
            yes: 'Ja, gern',
            no: 'Nein, jetzt nicht',
            declined: 'Einschalten kannst du später unter Einstellungen > Gebetszeiten.',
            placeTitle: 'Wo wohnt ihr?',
            placeBody: 'Dann berechnen wir die Zeiten für euer Gebiet. Eine Postleitzahl oder ein Ort reicht; wir speichern nur ein Gebiet von etwa einem Kilometer.',
            placeOther: 'Außerhalb der Niederlande oder ein Tablet an einem anderen Ort? Das stellst du unter Einstellungen > Standort ein.',
            placeSave: 'Diesen Ort verwenden',
            placeChosen: 'Zeiten für {label}',
            /** Golf 6c: waarom deze methode (de mazhab, nooit de keuken). */
            methodMadhab: 'Wir rechnen mit {method}, weil ihr der hanafitischen Schule folgt.',
            methodDefault: 'Wir rechnen mit {method}.',
            change: 'Ändern',
            methodChoose: 'Berechnungsmethode',
            becauseOne: 'Weil {name} dem Islam folgt.',
            becauseMany: 'Weil {names} dem Islam folgen.',
            next: 'Weiter',
            done: 'Fertig',
            enabled: 'Das nächste Gebet steht jetzt auf dem Board.',
            renew: 'Einwilligen und einschalten',
            off: 'Gebetszeiten sind aus. Das Board zeigt sie nicht, und es ertönt nichts.',
            turnOn: 'Gebetszeiten einschalten',
            offBody: 'Lieber eine Weile ohne? Dann verschwinden die Zeiten vom Board, und es ertönt nichts. Deine Auswahl für Methode und Ton bleibt gespeichert; ist das Wetter auch aus, löschen wir den Standort.',
            turnOff: 'Gebetszeiten ausschalten',
            turnOffConfirm: 'Gebetszeiten ausschalten? Einschalten geht hier jederzeit wieder.',
            turnOffYes: 'Ja, ausschalten',
            turnOffCancel: 'Doch nicht',
            renewOnly: 'Einwilligen',
            renewBody: 'Die Erklärung bei „Was zu unserer Familie passt“ hat sich geändert: Sie nennt jetzt auch zusätzliche Bereiche auf dem Board, wie diese Gebetszeiten. Willige hier erneut ein, um sie weiter zu nutzen.',
        },
        web: {
            consentRenewal: 'Die Erklärung bei „Was zu unserer Familie passt“ hat sich geändert: Sie nennt jetzt auch zusätzliche Bereiche auf dem Board, wie diese Gebetszeiten. Willige dort zuerst erneut ein.',
            consentLink: 'Zu Was zu unserer Familie passt',
            locationLink: 'Standort wählen',
            save: 'Speichern',
            saved: 'Gespeichert',
            today: 'Heute, {place}',
            ourTime: 'berechnet',
            offset: 'Abweichung',
            month: 'Monat',
            tableDays: {
                one: '{count} Tag aus dem Gebetsplan deiner Moschee',
                other: '{count} Tage aus dem Gebetsplan deiner Moschee',
            },
            tablePlaceholder: '2026-10-01;05:40;07:30;13:35;16:45;19:15;20:50',
            listen: 'Anhören',
            /** Tijdens het afspelen (review g6b ux r1: een stopknop, geen luidspreker met streep). */
            listenStop: 'Stopp',
            listenPlaying: 'Läuft',
            upload: 'Datei wählen',
            uploaded: 'Eigene Aufnahme in Gebrauch',
            uploadFailed: 'Nur eine m4a- oder mp3-Datei mit höchstens 5 Minuten und 5 MB.',
            last: 'Zuletzt: {items}',
            testPending: 'Test gesendet. Das Ergebnis steht hier innerhalb einer Minute.',
            uploadCall: 'Eigene {call}-Aufnahme hochladen',
            testResult: {
                played: 'Ertönte',
                card_locked: 'Still: Ton war aus',
                load_failed: 'Still: Aufnahme nicht geladen',
                skipped: 'Übersprungen',
            },
            volume: 'Lautstärke (Android, Fully Kiosk)',
            noTablets: 'Noch kein Tablet gekoppelt.',
            credits: {
                builtin: '{callTitle}, arabischer Stil: „{title}“ von {author}, auf',
                license: 'CC0 1.0 (gemeinfrei)',
                processing: 'Wir haben die Aufnahme in AAC und MP3 (mono) umgewandelt und so laut gemacht wie das Glöckchen. Sonst wurde nichts verändert.',
                tone: 'Das leise Glöckchen ist ein eigener Klang von AMUMIN.',
            },
        },
        attribution: 'Gebetszeiten: eigene Berechnung · Methode {method}',
        attributionTable: 'Gebetszeiten: Gebetsplan deiner Moschee',
        hijri: {
            months: [
                'Muharram',
                'Safar',
                'Rabi’ al-Awwal',
                'Rabi’ al-Achir',
                'Dschumada al-Ula',
                'Dschumada al-Achira',
                'Radschab',
                'Scha’ban',
                'Ramadan',
                'Schawwal',
                'Dhu l-Qa’da',
                'Dhu l-Hiddscha',
            ],
            pattern: '{day}. {month} {year} n. H.',
        },
    },
};
//# sourceMappingURL=weatherPrayer.de.js.map